import React from 'react';

import { withForm, SidePageV2 } from '@gogame/form';

import { LEFT_DRAWER_Z_INDEX } from '../../Sidebar/constants';
import { subscriptionSchema } from '../schema';
import Name from './Name';
import PayTo from './PayTo';
import Recipients from './Recipients';
import Schedule from './Schedule';

const SubscriptionForm = withForm({
  enableReinitialize: true,
  validationSchema: subscriptionSchema,
})(
  ({
    onClose,
    loading,
    onExited,
    open,
    title,
    subTitle,
    withPayTo,
    ...props
  }) => {
    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        open={open}
        loading={loading}
        width={800}
        direction={'right'}
        directionOfset={'65px'}
        zIndex={LEFT_DRAWER_Z_INDEX}
      >
        <SidePageV2.Title title={title} subTitle={subTitle} />
        <SidePageV2.Content>
          <Name />
          {withPayTo ? (
            <PayTo values={props?.values} onChange={props?.setValues} />
          ) : null}
          <Schedule />
          <Recipients />
        </SidePageV2.Content>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
      </SidePageV2>
    );
  }
);

export default SubscriptionForm;
